<app-module-error *ngIf="noMetric && !isFirstLoad" [noMetric]="true"></app-module-error>
<app-module-error *ngIf="noData && !isFirstLoad" [noData]="true"></app-module-error>

<div *ngIf="!noMetric && !noData && !isFirstLoad" class="my-ranking-container">
    <div class="profile-row">
        <div class="profile-subsection">
            <img [src]="profileData.imageSource" class="profile-image">
            <div class="profile-name">{{ profileData.name }}</div>    
        </div>
        <div class="profile-subsection">
            <div class="profile-role">
                {{ profileData.group }}
            </div>
            <div class="rank-description">
                <div style="padding-top: 2px;" cvLocalizedText langSection="My_Rank" langKey="Ranks">Ranks</div>
                <div ngbDropdown container="body" placement="bottom-right top-right">
                    <button type="button" class="icon-btn fill-whaleTail no-dropdown-caret" ngbDropdownToggle>
                        <svg class="icon-14 fill-hover-theUpsideDown">
                            <use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use>
                        </svg>
                    </button>
                    <div ngbDropdownMenu>
                        <div class="description-container">
                            <div class="description-title">
                                <svg class="icon-14 fill-theUpsideDown" style="margin-top: 2px; margin-right: 4px;"><use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use></svg>
                                <div class="title" cvLocalizedText langSection="My_Rank" langKey="Division">Divisions of Rankings</div>
                            </div>
                            <div class="description" cvLocalizedText langSection="My_Rank" langKey="Description">The rankings are divided into three specific ranks, different for every metric selected.</div>
                            <div class="description-rank-section">
                                <div class="drs-rank">
                                    <svg class="icon-24 fill-nessie"><use href="../App_Themes/clearview-default/icons/utility/arrow-up.svg#arrow-up"></use></svg>
                                    <div class="icon-tag" cvLocalizedText langSection="My_Rank" langKey="High">High</div>
                                </div>
                                <div class="drs-description">
                                    <span class="rankings">{{ high }}</span><span class="rankings-desc"> {{ description }}</span>
                                </div>
                            </div>
                            <div class="description-rank-section">
                                <div class="drs-rank">
                                    <svg class="icon-24 fill-mothMan"><use href="../App_Themes/clearview-default/icons/utility/medium.svg#medium"></use></svg>
                                    <div class="icon-tag" cvLocalizedText langSection="My_Rank" langKey="Medium">Mid</div>
                                </div>
                                <div class="drs-description">
                                    <span class="rankings">{{ mid }}</span><span class="rankings-desc"> {{ description }}</span>
                                </div>
                            </div>
                            <div class="description-rank-section">
                                <div class="drs-rank">
                                    <svg class="icon-24 fill-jungleWalrus"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg>
                                    <div class="icon-tag" cvLocalizedText langSection="My_Rank" langKey="Low">Low</div>
                                </div>
                                <div class="drs-description">
                                    <span class="rankings">{{ low }}</span><span class="rankings-desc"> {{ description }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rank-section">
        <div *ngFor="let d of data" class="rank-container">
            <div class="ranking-section">
                <div class="metric-name">{{ d.metricName }}</div>
                <div class="metric-info">{{ d.metricDisplayValue }}</div>
                <div class="position-container">
                    <div class="current-position">
                        {{ position }}:
                        <span *ngIf="d.rank !== 0" class="position-number">{{ d.rank }}/{{ d.totalGroups }}</span>
                        <span *ngIf="d.rank === 0" class="position-number" cvLocalizedText langSection="My_Rank" langKey="NA">N/A</span>
                    </div>
                </div>
            </div>
            <div class="ranking-section center-items">
                <div class="my-rank-legend">{{ myRank }}</div>
                <div *ngIf="d.ranking === 0" class="icon-section">
                    <svg class="icon-40 fill-nessie"><use href="../App_Themes/clearview-default/icons/utility/arrow-up.svg#arrow-up"></use></svg>
                    <div class="icon-tag" cvLocalizedText langSection="My_Rank" langKey="High">High</div>
                </div>
                <div *ngIf="d.ranking === 1" class="icon-section">
                	<svg class="icon-40 fill-mothMan"><use href="../App_Themes/clearview-default/icons/utility/medium.svg#medium"></use></svg>
                    <div class="icon-tag" cvLocalizedText langSection="My_Rank" langKey="Medium">Mid</div>
            	</div>
                <div *ngIf="d.ranking === 2" class="icon-section">
                    <svg class="icon-40 fill-jungleWalrus"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg>
                    <div class="icon-tag" cvLocalizedText langSection="My_Rank" langKey="Low">Low</div>
                </div>
                <div *ngIf="d.ranking === 3" class="icon-section">
                    <div class="icon-na" cvLocalizedText langSection="My_Rank" langKey="NA">N/A</div>
                </div>
            </div>
        </div>
    </div>
</div>
